import { atomWithStorage } from "jotai/utils";
import { LoginType } from "../models/enum/login";
import { atom } from "jotai";

export const loginTypeAtom = atomWithStorage<LoginType>(
  "loginType",
  LoginType.WEAUTH,
);

export const otpVerifyTokenAtom = atom<string | null>(null);
